/**
 * HSL to RGB, as the sky's palette and the add-to-cart shooting star use it.
 *
 * In a module of its own, apart from the sky's model (src/lib/cosmos-model.ts,
 * which re-exports it), so the add-to-cart flight, which loads with every
 * page, can tint its star without pulling the whole model into the shared
 * bundle; src/lib/sky-bundle.test.ts holds that line.
 */

export type Hsl = { h: number; s: number; l: number };
export type Rgb = { r: number; g: number; b: number };

const clamp01 = (v: number) => (v < 0 ? 0 : v > 1 ? 1 : v);

export function hslToRgb({ h, s, l }: Hsl): Rgb {
  const sat = clamp01(s / 100);
  const lig = clamp01(l / 100);
  const c = (1 - Math.abs(2 * lig - 1)) * sat;
  const hp = (((h % 360) + 360) % 360) / 60;
  const x = c * (1 - Math.abs((hp % 2) - 1));
  let r = 0;
  let g = 0;
  let b = 0;
  if (hp < 1) [r, g, b] = [c, x, 0];
  else if (hp < 2) [r, g, b] = [x, c, 0];
  else if (hp < 3) [r, g, b] = [0, c, x];
  else if (hp < 4) [r, g, b] = [0, x, c];
  else if (hp < 5) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];
  const m = lig - c / 2;
  return { r: Math.round((r + m) * 255), g: Math.round((g + m) * 255), b: Math.round((b + m) * 255) };
}
